import {
    ChangeDetectionStrategy,
    Component,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { AuthService } from '../../global-services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import {
    AMPLITUDE_EVENT_CATEGORIES,
    AMPLITUDE_EVENTS,
    AmplitudeEvent,
    AmplitudeService,
} from '../../global-services/amplitude.service';

@Component({
    templateUrl: 'landing-page.component.html',
    styleUrls: ['landing-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LandingPageComponent implements OnInit, OnDestroy {
    ngUnsubscribe: Subject<void> = new Subject<void>();

    constructor(
        private readonly amplitude: AmplitudeService,
        private readonly authService: AuthService,
        private readonly router: Router
    ) {
        // Adding a subscription to the isMobileDevice$ observable
        // In case the user is on a mobile device, redirect to the login page
        this.authService.isMobileDevice$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res) => {
                if (res) {
                    this.router.navigate(['/mobile-landing']);
                }
            });
    }

    ngOnInit() {
        const event = new AmplitudeEvent();
        event.eventName = AMPLITUDE_EVENTS.MYCARDS_LANDING_PAGE_OPENED_DESKTOP;
        this.logAmplitudeEvent(AMPLITUDE_EVENT_CATEGORIES.Engagement, event);
    }

    logAmplitudeEvent(
        type: AMPLITUDE_EVENT_CATEGORIES,
        event: AmplitudeEvent
    ): void {
        this.amplitude.logEvent(type, event.eventName, event.properties);
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
